var _path, _path2, _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroSectionTamperproof(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1028,
    viewBox: "0 0 1440 1028",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1913_31455)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 80H1440V945.957C1440 945.957 1160.5 1028 720 1028C279.5 1028 0 945.957 0 945.957V80Z",
    fill: "#6D2FEC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1913_31455",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 80,
    width: 1440,
    height: 948
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 80H1440V945.957C1440 945.957 1160.5 1028 720 1028C279.5 1028 0 945.957 0 945.957V80Z",
    fill: "#6D2FEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1913_31455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.99 585L-0.00982088 823",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.992 585L282.864 823L282.864 1172.5",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.49 823L560.992 585L639.99 585L512.99 822.5L512.99 1173.5L283.49 1173.5L283.49 823Z",
    fill: "url(#paint0_linear_1913_31455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.992 585L511.377 823L511.377 1165.5",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.99 585V823L719.99 1185.5",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.991 585L928.607 823L928.612 1179.5",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.992 585L1157.12 823L1157.12 1171",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.49 823L879.992 585L800.991 585L928.992 823L928.994 1176L1156.49 1176L1156.49 823Z",
    fill: "url(#paint1_linear_1913_31455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.99 585L1439.99 823",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 823L1440 823",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4004 783.135L1359.6 783.135",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6 743.865L1280.4 743.865",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.99 704L1199.99 704",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.391 664.135L1119.59 664.135",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.59 624.865L1040.39 624.865",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 585,
    width: 1440,
    height: 145,
    fill: "url(#paint2_linear_1913_31455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 360L1440 122",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.998 360L1157.13 122L1157.13 43.0001",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.998 360L928.614 122L928.614 50.0001",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 360L720 122L720 45.5001",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.998 360L511.382 122L511.382 49.5001",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.999 360L282.871 122L282.871 58.0002",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 360L-8.71852e-05 122",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 122L-5.72205e-05 122",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.6 161.865L80.3997 161.865",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.4 201.135L159.6 201.135",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 241L240 241",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.6 280.865L320.4 280.865",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.4 320.135L399.6 320.135",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440,
    y: 363,
    width: 1440,
    height: 320,
    transform: "rotate(180 1440 363)",
    fill: "url(#paint3_linear_1913_31455)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 80,
    fill: "#F7F2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1913_31455",
    x1: 588.99,
    y1: 590,
    x2: 583.5,
    y2: 887.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793BF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1913_31455",
    x1: 854.992,
    y1: 568,
    x2: 996.459,
    y2: 903.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793BF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1913_31455",
    x1: 720,
    y1: 594,
    x2: 720,
    y2: 730,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D2FEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1913_31455",
    x1: 2160,
    y1: 382.862,
    x2: 2160,
    y2: 683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211538,
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6D2FEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D2FEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1913_31455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1028,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionTamperproof);
export default __webpack_public_path__ + "static/media/heroSectionTamperproof.aeaf6a0e37612bfd9a1b63dc9b3f0a50.svg";
export { ForwardRef as ReactComponent };